import { useQuery } from '@apollo/client'
import Notification from '~/models/notification'
import { FIND_NOTIFICATION, FindNotificationResponse } from '~/api/notification'

export const useNotification = (): Notification|null => {
  const {data} = useQuery<FindNotificationResponse>(FIND_NOTIFICATION)

  return data ? data.notification : null
}

export const useNotificationExist = (): boolean => {
  const notification = useNotification()

  return !!notification && !!notification.message
}